import api from '../collums-components/api/config';

class SettingsApi {
    static getSetting(settingName) {
        return api.request({
            method: 'GET',
            url: `/settings/${settingName}`
        });
    }

    static updateSetting(settingName, data) {
        return api.request({
            method: 'PUT',
            url: `/settings/${settingName}`,
            data: data
        });
    }
}

export default SettingsApi;
